import { compose, path } from "ramda";
import { createSelector } from "reselect";
import * as model from "./model";

export const scopeSelector = state => state.modules.booking;

export const getBookingInfoApi = compose(
  path(["api", "getBookingInfo"]),
  scopeSelector
);

export const applyPromoCodeApi = compose(
  path(["api", "applyPromoCode"]),
  scopeSelector
);
export const deleteSubObjectiveApi = compose(
  path(["api", "deleteSubObjective"]),
  scopeSelector
);
export const getBookingDetailApi = compose(
  path(["api", "getBookingDetail"]),
  scopeSelector
);

export const fetchBookingDetail = createSelector(
  [getBookingDetailApi],
  api => api.data
);
export const bookTimeApi = createSelector(
  [
    compose(path(["api", "bookTime"]), scopeSelector),
    (_, { match }) => match.params
  ],
  (apis, params) => apis[params.id] || {}
);

export const rescheduleBookingApi = compose(
  path(["api", "rescheduleBooking"]),
  scopeSelector
);

export const cancelBookingApi = compose(
  path(["api", "cancelBooking"]),
  scopeSelector
);

export const getBookedCallsApi = compose(
  path(["api", "getBookedCalls"]),
  scopeSelector
);

export const getBookedCallDetailApi = compose(
  path(["api", "getBookedCallDetail"]),
  scopeSelector
);

export const getWaitingForFeedbackInsidersApi = compose(
  path(["api", "getWaitingForFeedbackInsiders"]),
  scopeSelector
);

export const getBookErrors = createSelector([bookTimeApi], book =>
  model.formatErrors(book.error)
);

export const isBookingCall = createSelector(
  [bookTimeApi],
  book => book.isFetching
);

export const getCurrentBookingInfo = createSelector(
  [getBookingInfoApi, (_, { match }) => match],
  (api, { params }) => api.data && model.getCurrentBooking(api.data, params.id)
);

export const getBookedCall = createSelector(
  [getBookedCallsApi, (_, { match }) => match],
  (api, { params }) => api.data && model.getBookedCallById(api.data, params.id)
);

export const fetchCallDetails = createSelector(
  [getBookedCallDetailApi],
  api => api.data
);

export const getCallObjectivesApi = compose(
  path(["api", "getCallObjectives"]),
  scopeSelector
);



// WEBPACK FOOTER //
// ./src/modules/booking/selectors.js